/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Profile_Passkey_Added_OnInputs */



/**
* | output |
* | --- |
* | "Added {date}" |
*
* @param {Profile_Passkey_Added_OnInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const profile_passkey_added_on = /** @type {((inputs: Profile_Passkey_Added_OnInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Passkey_Added_OnInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Ajoutée le ${i?.date}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Añadida el ${i?.date}`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`Adicionada em ${i?.date}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Aggiunta il ${i?.date}`)
	return /** @type {LocalizedString} */ (`Added ${i?.date}`)
});